import { shallowRef } from "vue";

import { jobs as jobsApi } from "~/api";
import { fetch } from "~/utils/api";

/**
 * Composable for job toggle and execute actions.
 *
 * @param {object} options
 * @param {Function} options.onToggle - called with (jobId, enabled) after successful toggle
 * @param {Function} options.onExecute - called with (jobId) after successful execute
 * @returns {{
 *   actionAlert: import('vue').ShallowRef<object|null>,
 *   handleToggle: Function,
 *   handleExecute: Function
 * }}
 */
export function useJobActions({ onToggle, onExecute }) {
  const actionAlert = shallowRef(null);

  async function handleToggle(job, enabled) {
    actionAlert.value = null;
    await fetch({
      alert: actionAlert,
      apiMethod: jobsApi.toggle,
      onSuccess(data) {
        onToggle(job.id, enabled);
        actionAlert.value = data;
      },
      requestArgs: { data: { enabled }, params: { id: job.id } }
    });
  }

  async function handleExecute(job) {
    actionAlert.value = null;
    await fetch({
      alert: actionAlert,
      apiMethod: jobsApi.execute,
      onSuccess(data) {
        onExecute(job.id);
        actionAlert.value = data;
      },
      requestArgs: { params: { id: job.id } }
    });
  }

  return { actionAlert, handleExecute, handleToggle };
}
